import { ShelvingStoreInterface, storeRoomInterface } from "../store";

export const collectProject = (
    project: DeepPartial<{
        roomState: storeRoomInterface;
        shelvingState: ShelvingStoreInterface;
    }>
): DeepPartial<{
    roomState: storeRoomInterface;
    shelvingState: ShelvingStoreInterface;
}> => {
    const front = project?.shelvingState?.shelving?.front;
    const back = project?.shelvingState?.shelving?.back;
    const left = project?.shelvingState?.shelving?.left;
    const right = project?.shelvingState?.shelving?.right;

    const cleanSide = <T extends { sections?: Array<{ items?: any[] }> }>(side?: T): T | undefined => {
        if (!side) return side;
        if (!Array.isArray(side.sections)) return { ...side };

        const sections = side.sections.map((s) => {
            if (!Array.isArray(s.items)) return { ...s };
            const items = s.items.map((item) => {
                if (!item || typeof item !== "object") return item;
                const { brackets, amps, edges, rods, type, railHoles, price, ...rest } = item as Record<string, any>;
                return {
                    ...rest,
                    parts: (rest?.parts || []).map((p: any) => {
                        const { type, ...o } = p;
                        return { ...o };
                    }),
                };
            });
            return { ...s, items };
        });

        return { ...(side as object), sections } as T;
    };

    const frontClean = cleanSide(front);
    const backClean = cleanSide(back);
    const leftClean = cleanSide(left);
    const rightClean = cleanSide(right);

    return {
        ...project,
        ...(project?.shelvingState
            ? {
                  shelvingState: {
                      ...project.shelvingState,
                      shelving: {
                          ...project.shelvingState.shelving,
                          ...(frontClean ? { front: frontClean } : {}),
                          ...(backClean ? { back: backClean } : {}),
                          ...(leftClean ? { left: leftClean } : {}),
                          ...(rightClean ? { right: rightClean } : {}),
                      },
                  },
              }
            : {}),
    };
};
